import { createSlice } from '@reduxjs/toolkit';

const initialState = {};
export const fileUploadSlice = createSlice({
  name: 'fileUploads',
  initialState,
  reducers: {
    resetFileUpload: (state) => initialState,
    addFileUpload: (state, action) => ({ ...state, ...action.payload }),
  },
});

// Action creators are generated for each case reducer function
export const { resetFileUpload, addFileUpload } = fileUploadSlice.actions;

export default fileUploadSlice.reducer;
